import { Pipe, PipeTransform } from '@angular/core';
import { IArticleSalesHistoryItem } from '../../pages/articles/core/interfaces/IArticleSalesHistoryItem';
import { DecimalPipe } from '@angular/common';

@Pipe({
    name: 'articleVariantSaleHistoryItemByStore',
    standalone: false
})
export class ArticleVariantSaleHistoryItemByStorePipe implements PipeTransform {

  public constructor(
    private readonly _decimalPipe: DecimalPipe
  ) {}

  public transform(
    items: IArticleSalesHistoryItem[],
    articleVariantId: number,
    storeId: number,
    sum?: 'cols' | 'rows'
  ): string {
    if (sum) {
      const fItems = items
        .filter(
          i => sum === 'rows' ? i.storeId === storeId : i.articleVariantId === articleVariantId
        );
      const totalAmount = fItems.reduce((sum, i) => sum + i.amount, 0);
      const totalCount = fItems.reduce((sum, i) => sum + i.count, 0);

      return `${totalAmount.toCurrency()} / ${this._decimalPipe.transform(totalCount)}`;
    } else {
      const fItem = items
        .find(i => i.articleVariantId === articleVariantId && i.storeId === storeId);

      if (!fItem) {
        return null;
      }

      return `${fItem.amount.toCurrency()} / ${this._decimalPipe.transform(fItem.count)}`;
    }
  }
}
